<template>
    <div>
    <!-- Apropos-->
        <section class="page-section" id="about">
            <div class="container">
                <div class="text-center">
                    <h2 class="section-heading text-uppercase">A propos</h2>
                    <h3 class="section-subheading text-muted">
                        Mise en place de la plateforme SneakersAddict
                    </h3>
                </div>
                <ul class="timeline">
                    <li style="list-style:none">
                        <div class="timeline-image">
                            <img
                                class="rounded-circle img-fluid"
                                src="../assets/img/about/1.jpg"
                                alt="..."
                            />
                        </div>
                        <div class="timeline-panel">
                            <div class="timeline-heading">
                                <h4>2019-2020</h4>
                                <h4 class="subheading">Nos débuts laborieux</h4>
                            </div>
                            <div class="timeline-body">
                                <p class="text-muted">
                                    Après plusieurs mois, acharné de travail
                                    pour concrétiser notre projet nous avons
                                    essuyé de nombreux échecs. Mais comme on
                                    le dit souvent le plus important c'est pas
                                    la chute c'est l'attérissage, ainsi nous
                                    sommes revenus plus déterminés que jamais
                                    après chaque obstable sur notre route afin
                                    de vous offrir le meilleur en terme de
                                    sneakers.
                                </p>
                            </div>
                        </div>
                    </li>
                    <li class="timeline-inverted" style="list-style:none">
                        <div class="timeline-image">
                            <img
                                class="rounded-circle img-fluid"
                                src="../assets/img/about/2.jpg"
                                alt="..."
                            />
                        </div>
                        <div class="timeline-panel">
                            <div class="timeline-heading">
                                <h4>Janvier 2021</h4>
                                <h4 class="subheading">
                                    Création de la première boutique
                                </h4>
                            </div>
                            <div class="timeline-body">
                                <p class="text-muted">
                                    Suite un succès exponentiel de notre
                                    plateforme, se classsant dans les sites
                                    et applications les plus visités sur l'année
                                    de 2021. Nous avons voulu voir grand, très
                                    grand, en revoyant nos objectifs avec plus
                                    d'ambition. Malgrès les difficultés
                                    sanitaires actuelles qui auraient pû nous
                                    contraindre à le faire. <br />
                                    Nous avons ouvert !!
                                    <span class="text-uppercase text-dark"
                                        >notre première boutique sur Paris</span
                                    >
                                </p>
                            </div>
                        </div>
                    </li>
                    <li style="list-style:none">
                        <div class="timeline-image">
                            <img
                                class="rounded-circle img-fluid"
                                src="../assets/img/about/3.jpg"
                                alt="..."
                            />
                        </div>
                        <div class="timeline-panel">
                            <div class="timeline-heading">
                                <h4>Juillet 2021</h4>
                                <h4 class="subheading">
                                    Transition vers une enseigne
                                </h4>
                            </div>
                            <div class="timeline-body">
                                <p class="text-muted">
                                    Encore une fois, notre succès a été
                                    retentissant notre présence devenait
                                    presque vitale. Pour commecencer, nous avons
                                    conquis le coeur des fans franciliens en
                                    ouvrant une dizaine de boutiques. Puis dans
                                    toute la France métropolitaine.
                                </p>
                            </div>
                        </div>
                    </li>
                    <li class="timeline-inverted" style="list-style:none">
                        <div class="timeline-image">
                            <img
                                class="rounded-circle img-fluid"
                                src="../assets/img/about/4.jpg"
                                alt="..."
                            />
                        </div>
                        <div class="timeline-panel">
                            <div class="timeline-heading">
                                <h4>Janvier 2022</h4>
                                <h4 class="subheading">
                                    Transition vers une enseigne mondiale
                                </h4>
                            </div>
                            <div class="timeline-body">
                                <p class="text-muted">
                                    SneakersAddict va au courant de l'année
                                    s'ouvrir au marché mondial en touchant un
                                    public toujours aussi passionné avec une
                                    bonne paire aux pieds 😁. SneakersAddict sera
                                    bientot une référence aux quatres coins du
                                    monde pour les personnes qui désirent
                                    apprendre et comprendre cet univers si
                                    merveilleux.
                                </p>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </section>    
        </div>
</template>